import { render, staticRenderFns } from "./IVideo.vue?vue&type=template&id=09dcce12&scoped=true&"
import script from "./IVideo.vue?vue&type=script&lang=js&"
export * from "./IVideo.vue?vue&type=script&lang=js&"
import style0 from "./IVideo.vue?vue&type=style&index=0&id=09dcce12&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dcce12",
  null
  
)

export default component.exports